var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.8696 19.5651C35.8696 10.5651 28.5652 3.26074 19.5652 3.26074C10.5652 3.26074 3.26086 10.5651 3.26086 19.5651C3.26086 27.4564 8.86956 34.027 16.3043 35.5434V24.4564H13.0435V19.5651H16.3043V15.489C16.3043 12.3423 18.8641 9.78248 22.0109 9.78248H26.087V14.6738H22.8261C21.9293 14.6738 21.1956 15.4075 21.1956 16.3042V19.5651H26.087V24.4564H21.1956V35.7879C29.4293 34.9727 35.8696 28.027 35.8696 19.5651Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3a94441c5b35af79ae2981b396dd08f5.svg";
export { ForwardRef as ReactComponent };